var map = {
	"./add.svg": "76a4",
	"./ai.svg": "5b53",
	"./ashbin.svg": "1430",
	"./at.svg": "a986",
	"./bad.svg": "7104",
	"./bean.svg": "260d",
	"./broadcast.svg": "57e4",
	"./card.svg": "5d4a",
	"./comment.svg": "c47d",
	"./discount.svg": "b5a1",
	"./fabulous.svg": "78b5",
	"./file-open.svg": "b453",
	"./friendster.svg": "5c83",
	"./good-fill.svg": "2b3f",
	"./good.svg": "0265",
	"./hide.svg": "a010",
	"./hongbao.svg": "77b9",
	"./lock.svg": "96192",
	"./money.svg": "cf44",
	"./morevert.svg": "1cfd",
	"./onlineNum.svg": "d8ec",
	"./picture.svg": "4092",
	"./qq.svg": "cd8f",
	"./question.svg": "9872",
	"./quick-broadcast.svg": "291a",
	"./quick-red.svg": "9161",
	"./quick-reward.svg": "95a6",
	"./quick-topic.svg": "c7ff",
	"./red.svg": "341f9",
	"./reward.svg": "37f8",
	"./setting.svg": "5de8",
	"./share.svg": "bd5b",
	"./smile.svg": "0c16",
	"./time.svg": "79aa",
	"./top.svg": "755d",
	"./warning.svg": "daa9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";